export default "__VITE_ASSET__DbWD8k$A__"